import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PeriodService } from 'src/app/services/period.service';

@Component({
  selector: 'period-chooser',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './period-chooser.component.html',
  styleUrl: './period-chooser.component.scss',
})
export class PeriodChooserComponent {
  constructor(public periodService: PeriodService) {}

  previousPeriodClick() {
    this.periodService.previous();
  }

  nextPeriodClick() {
    this.periodService.next();
  }
}
